import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show banner after 1 second delay
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-[70] p-4 md:p-6"
        >
          <div className="max-w-7xl mx-auto">
            <div className="bg-[#1e293b]/95 backdrop-blur-xl border border-white/10 p-6 md:p-8 shadow-2xl shadow-black">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
                {/* Icon */}
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#f97316]/10 border border-[#f97316]/20 flex items-center justify-center">
                    <Cookie className="w-6 h-6 text-[#f97316]" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-2">
                    Мы используем cookies
                  </h3>
                  <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                    Этот сайт использует cookies и сервисы аналитики (Яндекс.Метрика и Google Analytics) для улучшения работы сайта и анализа трафика. 
                    Продолжая использовать сайт, вы соглашаетесь с использованием cookies.{' '}
                    <a href="#" className="text-[#f97316] hover:text-white transition-colors underline">
                      Подробнее
                    </a>
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                  <button
                    onClick={handleAccept}
                    className="px-6 py-3 bg-[#f97316] text-black font-bold uppercase tracking-wider hover:bg-white transition-colors whitespace-nowrap rounded-lg"
                  >
                    Принять
                  </button>
                  <button
                    onClick={handleDecline}
                    className="px-6 py-3 border border-white/20 text-white font-bold uppercase tracking-wider hover:bg-white/10 transition-colors whitespace-nowrap rounded-lg"
                  >
                    Отклонить
                  </button>
                </div>

                {/* Close button */}
                <button
                  onClick={handleDecline}
                  className="absolute top-4 right-4 text-white/50 hover:text-white transition-colors"
                  aria-label="Закрыть"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
